export default __webpack_public_path__ + "static/media/sowmz-lop.aec860a5.jpg";